// extracted by mini-css-extract-plugin
export default {"mainPanel":"YXKFwa7UgTC0kyXzJZqy","mainPanelWhite":"ziMdPEoBS8KSoJO5_2PA"};